import React from 'react';
import PropTypes from 'prop-types';
import {
  map,
  uniqBy,
  flatten,
} from 'lodash';
import { Typography } from '@material-ui/core';

import EventDataAutocomplete from '../../../../../../forms/EventDataAutocomplete';

export const FormEventDataComponent = (props) => {
  const {
    formRequest,
    setFormRequest,
  } = props;

  const allCustomFields = map(uniqBy(flatten(formRequest.eventTemplates.map((et) => et.eventData)), 'id'), (item) => item);
  const notUsedCustomFields = allCustomFields
    .filter((ed) => (formRequest.hiddenEventDataIds || []).indexOf(ed.id) < 0)
    .filter((ed) => (formRequest.formEventDataIds || []).indexOf(ed.id) < 0);

  const hiddenEventData = allCustomFields.filter((ed) => (formRequest.hiddenEventDataIds || []).indexOf(ed.id) >= 0);
  const formEventData = allCustomFields.filter((ed) => (formRequest.formEventDataIds || []).indexOf(ed.id) >= 0);

  const handleChangeHiddenEventDataIds = (e, changedValue) => {
    setFormRequest({
      ...formRequest,
      hiddenEventDataIds: changedValue.map((ed) => ed.id),
    });
  };

  const handleChangeFormEventDataIds = (e, changedValue) => {
    setFormRequest({
      ...formRequest,
      formEventDataIds: changedValue.map((ed) => ed.id),
    });
  };

  return (
    <div>
      <Typography variant="subtitle1" gutterBottom>Setup Form Custom Fields</Typography>
      <Typography variant="caption" gutterBottom>
        Only custom fields associated with the selected workflow
        in the form will be available. If you wish to hide or avoid
        users filling out certain fields you can specify those below.
      </Typography>

      <EventDataAutocomplete
        multiple
        label="Hidden Custom Fields"
        helperText="Select any custom fields you wish to hide in this form"
        eventData={notUsedCustomFields}
        value={hiddenEventData}
        onChange={handleChangeHiddenEventDataIds}
      />

      {
        formRequest.type === 'Multiple'
          && (
            <div>
              <Typography variant="caption" gutterBottom>
                &quot;Multiple&quot; forms allow users to select and submit
                multiple workflows in the form, you might decide some
                custom fields are redundant/duplicats. These could be fields
                such as <b>Name</b> or <b>Email</b> where you would not want someone filling
                in the same data for each workflow they choose to fill out.
                Specify below which custom fields should be designated
                as &quot;Form&quot; fields and displayed at the top
                of the form to only be filled out once by the user.
              </Typography>
              <EventDataAutocomplete
                multiple
                label="Form Level Custom Fields"
                helperText="Select any custom fields you wish place at the top of the form so users don't have to fill them out for each workflow they select"
                eventData={notUsedCustomFields}
                value={formEventData}
                onChange={handleChangeFormEventDataIds}
              />
            </div>
          )
      }

    </div>
  );
};

FormEventDataComponent.propTypes = {
  formRequest: PropTypes.object,
  setFormRequest: PropTypes.func,
};
FormEventDataComponent.defaultProps = {
  formRequest: null,
  setFormRequest: () => {},
};

export default FormEventDataComponent;
